import { $http } from "@/utils/service";

//注册领取数据请求   请求参数接口
interface activityRegisterParams {
  id: number;
}
//注册领取数据请求   返回参数类型
export interface activityResponse {
  userId:number;
  id: number;
  bannerUrls: string;
  h5Title: string; //h5标题
  price: number; //活动标价
  scribingPrice: number; //划线价
  activityTitle: string; //活动标题
  endTime: number; //	结束时间(时间戳)
  activityProcess: string; //	活动流程
  ruleDesc: string; //规则说明
  detailsImgurl: string; //	详情页图片
  footBtnText: string; //底部按钮文案
  openGroupExplain: string; //开团说明
  joinPeopleNum: number; //参与人数
}

export interface startGroupResponse {
  id: number;
  endTime: number; //	结束时间(时间戳)
  activitySharePosterUrl: string; //	开始组团页  分享海报
  activityShareBtn: string; //活动分享按钮
  openGroupExplain: string; //开团说明
  openGroupText: string; //开团文案
  beginGuideBtn: string; //活动分享按钮 按钮名称
  totalMember: number; //总共的参团人数
  joinMember: number; //参加的人数
  bannerUrls: string;
  openGroupSuccessUrl: string;
  successGuideBtn:""
}
export interface GroupShareResponse {
  id: number;//id
  shareTitle: string; //分享标题
  shareText: string; //分享文本
  shareImgUrl: string; //分享图片
}

export interface SubscriptionNotifyResponse {
  isSubscriptionOA: boolean
}

export interface GetSubscriptionResponse {
  isSub: boolean
}

export class Activity {
  public static async activityGet(
    params: activityRegisterParams
  ): Promise<activityResponse> {
    try {
      const response = await $http.get<activityResponse>({
        url: "/content/openGroup/registerInfo/get",
        params,
        options: { loading: false, mock: false, error: true },
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //开始组团页
  public static async startGroupDataGet(params: {
    id: number;
  }): Promise<startGroupResponse> {
    try {
      const response = await $http.get<startGroupResponse>({
        url: "/content/openGroup/beginGroupInfo/get",
        params,
        options: { loading: false, mock: false, error: true },
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // 组团分享
  public static async groupShare(params: {
    id: number;
  }): Promise<GroupShareResponse> {
    try {
      const response = await $http.get<GroupShareResponse>({
        url: "/content/openGroup/shareInfo/get",
        params,
        options: { loading: false, mock: false, error: true },
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public static async subscriptionNotify(body: {
    userId: number;
    code: string;
  }): Promise<SubscriptionNotifyResponse> {
    console.log("subscriptionNotify", body);
    try{
      const response = await $http.post<SubscriptionNotifyResponse>({
        url: "/resource/officialAccount/subOfficialAccount",
        body,
        options: {loading: false, mock: false, error: true}
      })
      return Promise.resolve(response)
    }catch (error) {
      return Promise.reject(error)
    }
  }

  public static async getSubscriptionStatus(params: {
    userId: number;
  }): Promise<GetSubscriptionResponse> {
    console.log("getSubscriptionStatus", params);
    try{
      const response = await $http.get<GetSubscriptionResponse>({
        url: '/resource/officialAccount/selectUserSub',
        params,
        options: { loading: false, mock: false, error: true },
      })
      return Promise.resolve(response)
    }catch (error) {
      return Promise.reject(error)
    }
  }
}
